export function refreshCallback(data) {
    const msgData = {
        type: 2 /* TimerMessageTypes.Refresh */,
        timerData: data,
    };
    // send data back to main thread
    self.postMessage(msgData);
}
